import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { BottomSheet } from '@components'
import { useGoBack } from '@src/utils'

interface VideoCallDetailsModalProps {
  children: React.ReactNode
}

export const VideoCallDetailsModal = ({ children }: VideoCallDetailsModalProps) => {
  const styles = useStyleSheet(themedStyles)
  const goBack = useGoBack()

  return (
    <BottomSheet secondaryButton={{ text: 'Dismiss', onPress: goBack }}>
      <View style={styles.modalContent}>{children}</View>
    </BottomSheet>
  )
}

const themedStyles = StyleService.create({
  modalContent: {
    flex: 0,
    flexBasis: 'auto',
    marginTop: 16,
  },
})
